import React, {Component} from 'react';
import {
  Container,
  Row,
  Col,
  Progress
} from 'reactstrap';

import Link from 'react-router-dom/NavLink';
import moment from "moment/moment";

import Button from '../../../shared/components/Button';
import MoneyDisplay from '../../../shared/components/MoneyDisplay';
import SearchableDataTable from '../../../shared/components/SearchableDataTable';
import DropdownButton from '../../../shared/components/DropdownButton';
import Pills from '../../../shared/components/Pills';

import {
  formatStatus,
  recursivelyLoadAllPages,
  emojiUrlForRating,
  dayIsInPast ,
  firstNonZeroOrOne,
  alphabeticallySort,
  textContains,
  statusSort,
  daysSinceEpoch
} from '../../../shared/utils';
import ExtendCampaignModal from "../../../shared/components/ExtendCampaignModal";
import Promise from "bluebird";

class ProviderCampaignList extends Component {
  constructor(props){
    super(props);

    this.state = {
      searchText:'',
      isLoading:false,
      currentlyShowing:25,
      filter:'Recent',
      isHoverBudget: {},
      extendModal: {isModalOpen:false, campaignId: undefined}
    };
  }

  componentDidMount(){
    this.setState({isLoading:true});

    Promise.all([
      recursivelyLoadAllPages(this.props.loadKPIsForAllCampaigns),
      recursivelyLoadAllPages(this.props.loadCampaigns,100),
      recursivelyLoadAllPages(this.props.loadBrands),
    ])
      .then(() => this.setState({isLoading:false}))
      .catch(() => this.setState({isLoading:false}));
  }

  handleEditClickedWhilePaused(campaignId){
    this.props.revertCampaignToDraft(campaignId)
      .then(() => this.props.history.push(`/superadmin/tutorial/create/${campaignId}`))
  }

  submitExtendClick(data){
    return this.props.extendCampaign(data.campaignId, data.newLifetimeBudget, data.resumeDate, data.endDate)
      .then((res)=> {
        return new Promise((resolve, reject) => {
          resolve(res);
          this.setState({extendModal: {...this.state.extendModal, isModalOpen: false}})
        })
      })
  }

  handleExtendClick(campaign){
    const {id, lifetimeBudget, budgetSpent, launchDate, endDate, status} = campaign
    this.setState({
      extendModal:{
        ...this.state.extendModal,
        isModalOpen:true,
        campaignId: id,
        currentThreshold: lifetimeBudget,
        amountSpent: budgetSpent,
        launchDate: launchDate,
        endDate: endDate,
        status: status,
        onSubmit: (data) => {
          return this.submitExtendClick(data)
        },
        onCancel : ()=>{this.setState({extendModal: {...this.state.extendModal, isModalOpen:false}})}
      }
    })
  }

  updateFilter(filter){
    this.setState({filter: filter, items: this.getFilteredList(this.props.campaigns, filter)})
  }

  getFilteredList(items, filter){
    switch (filter){
      case 'All':
        return items
      case 'Recent':
        const now = moment().startOf("day")
        return items.filter(item=>now.diff(moment(item.launchDate).startOf("day"), 'days')<90)
      case 'Active':
        return items.filter(item=>item.status==='active')
    }
    console.error('Filter Experiences by ' + filter + ' couldn\'t be handled')
    return items
  }

  renderFilterSection(){
    return <Row>
      <Col xs='8'>
        <Pills
          selected={this.state.filter}
          onChange={(filter) => this.updateFilter(filter)}
          states={['Recent','Active','All']}
          titles={['Recent','Active','All']}
      />
    </Col>
    </Row>

  {/*return <ButtonGroup className='searchable-table_filter-buttons'>*/}
      {/*<Button color='link' active={this.state.filter === 'Recent'} onClick={()=>this.updateFilter('Recent')}>Recent</Button>*/}
      {/*<Button color='link' active={this.state.filter === 'Active'} onClick={()=>this.updateFilter('Active')}>Active</Button>*/}
      {/*<Button color='link' active={this.state.filter === 'All'} onClick={()=>this.updateFilter('All')}>All</Button>*/}
    {/*</ButtonGroup>*/}
  }

  budgetValue(campaign, budgetProgress){
    const isHoveredItem = this.state.isHoverBudget[campaign.id] === true;
    return (
      <div>
        <Progress
          className='BudgetProgressBar'
          value={(budgetProgress / campaign.lifetimeBudget) * 100}
        />
        <small
          onMouseEnter={() => this.setState({isHoverBudget:{...this.state.isHoverBudget, [campaign.id]: true }})}
          onMouseLeave={() => this.setState({isHoverBudget:{...this.state.isHoverBudget, [campaign.id]: false }})}>
          <MoneyDisplay>{Math.abs(isHoveredItem ? budgetProgress : campaign.lifetimeBudget - budgetProgress)}</MoneyDisplay>
          &nbsp;{ isHoveredItem ? 'spent' : (campaign.lifetimeBudget - budgetProgress) > 0 ? 'remaining' : 'over budget'}
        </small>
      </div>
    )
  }


  renderButtonsForCampaign(campaign){
    const endDateInPast = campaign.endDate && dayIsInPast(campaign.endDate);

    if(campaign.status === 'draft'){
      return (
        <div className='pull-right'>
          <Button
            linkHref={`/superadmin/tutorial/create/${campaign.id}`}
            size='sm'
            textColor='#666666'
            borderColor='#cccccc'
            backgroundColor='#fff'
          >
            Edit
          </Button>
          &nbsp;&nbsp;
          <DropdownButton
            options={[
              {
                text:'Duplicate',
                onClick:() => this.props.duplicateCampaign(campaign.id)
              },
              {
                text:'Move to trash',
                confirmationText:'This is permanent and can not be reverted.',
                confirmationAcceptText:'Confirm',
                confirmationRejectText:'Cancel',
                onClick:() => this.props.deleteCampaign(campaign.id)
              }
            ]}
          />
        </div>
      );
    }

    if(campaign.status === 'pendingAdjoy' || campaign.status === 'pendingAgency'){
      return (
        <div className='pull-right'>
          <Button
            linkHref={`${this.props.match.url}/${campaign.id}/review`}
            size='sm'
            textColor='#666666'
            borderColor='#cccccc'
            backgroundColor='#fff'
          >
            Review
          </Button>
          &nbsp;&nbsp;
          <DropdownButton
            options={[
              {
                text:'Duplicate',
                onClick:() => this.props.duplicateCampaign(campaign.id)
              }
            ]}
          />
        </div>
      );
    }

    if(campaign.status === 'active' || campaign.status === 'ready'){
      return (
        <div className='pull-right'>
          <Button
            linkHref={`${this.props.match.url}/${campaign.id}/reports`}
            size='sm'
            textColor='#666666'
            borderColor='#cccccc'
            backgroundColor='#fff'
          >
            Results
          </Button>
          &nbsp;&nbsp;
          <DropdownButton
            options={[
              {
                text:'Extend',
                onClick:() => this.handleExtendClick(campaign)
              },
              {
                text:'Pause',
                confirmationText:'Users will not be able to view or complete this experience.',
                confirmationAcceptText:'Confirm',
                confirmationRejectText:'Cancel',
                onClick:() => this.props.suspendCampaign(campaign.id)
              },
              {
                text:'Duplicate',
                onClick:() => this.props.duplicateCampaign(campaign.id)
              }
            ]}
          />
        </div>
      );
    }

    if(campaign.status === 'suspended' && endDateInPast){
      return (
        <div className='pull-right'>
          <Button
            linkHref={`${this.props.match.url}/${campaign.id}/reports`}
            size='sm'
            textColor='#666666'
            borderColor='#cccccc'
            backgroundColor='#fff'
          >
            Results
          </Button>
          &nbsp;&nbsp;
          <DropdownButton
            options={[
              {
                text:'Edit',
                onClick:() => this.handleEditClickedWhilePaused(campaign.id)
              },
              {
                text:'Resume',
                confirmationTitle:'Sorry',
                confirmationText:'End date cannot be in the past. Please update end date before resuming.',
                confirmationAcceptText:'Confirm',
                confirmationRejectText:'Cancel',
                onClick:() => {}
              },
              {
                text:'Duplicate',
                onClick:() => this.props.duplicateCampaign(campaign.id)
              }
            ]}
          />
        </div>
      )

    }

    if(campaign.status === 'suspended' && !endDateInPast){
      return (
        <div className='pull-right'>
          <Button
            linkHref={`${this.props.match.url}/${campaign.id}/reports`}
            size='sm'
            textColor='#666666'
            borderColor='#cccccc'
            backgroundColor='#fff'
          >
            Results
          </Button>
          &nbsp;&nbsp;
          <DropdownButton
            options={[
              {
                text:'Edit',
                onClick:() => this.handleEditClickedWhilePaused(campaign.id)
              },
              {
                text:'Resume',
                confirmationText:'Users will be now able to complete this experience and earn rewards.',
                confirmationAcceptText:'Confirm',
                confirmationRejectText:'Cancel',
                onClick:() => this.props.resumeCampaign(campaign.id)
              },
              {
                text:'Duplicate',
                onClick:() => this.props.duplicateCampaign(campaign.id)
              }
            ]}
          />
        </div>
      )

    }

    if(campaign.status === 'outOfFunds' || campaign.status === 'complete'){
      return (
        <div className='pull-right'>
          <Button
            linkHref={`${this.props.match.url}/${campaign.id}/reports`}
            size='sm'
            textColor='#666666'
            borderColor='#cccccc'
            backgroundColor='#fff'
          >
            Results
          </Button>
          &nbsp;&nbsp;
          <DropdownButton
            options={[
              {
                text:'Extend',
                onClick:() => this.handleExtendClick(campaign)
              },
              {
                text:'Duplicate',
                onClick:() => this.props.duplicateCampaign(campaign.id)
              }
            ]}
          />
        </div>
      );
    }

    return null;
  }

  renderName(name){
    if(!name || name === 'Untitled campaign' || name === 'Unknown brand'){
      return <i>{name}</i>
    } else {
      return name;
    }
  }

  render(){
    const { campaigns } = this.props;
    const filteredCampaigns = this.getFilteredList(campaigns, this.state.filter)

    const { isLoading } = this.state;

    return (
      <Container>
        <ExtendCampaignModal {...this.state.extendModal}/>
        <Row className='EntityList-title'>
          <Col xs='6'>
            <h1>
              Experiences
            </h1>
          </Col>
          <Col xs='6'>
            <Button
              className='pull-right'
              linkHref='/superadmin/tutorial/create/new'
            >
              Create Experience
            </Button>
          </Col>
        </Row>
        <Row>
          <Col xs='12'>
            <SearchableDataTable
              items={isLoading ? [] : filteredCampaigns}
              emptyText='Loading experiences...'
              searchPromptText='Search by name or brand'
              getFilterSection={() => this.renderFilterSection()}
              defaultSortColumn={'startdate'}
              defaultSortFunc={(a,b) => firstNonZeroOrOne([
                daysSinceEpoch(b.launchDate) - daysSinceEpoch(a.launchDate),
                alphabeticallySort(a.name,b.name),
                statusSort(a.status, b.status)
              ])}
              columns={[
                {
                  name:'status',
                  width:12,
                  sortFunc:(a,b) => firstNonZeroOrOne([
                    alphabeticallySort(formatStatus(a.status), formatStatus(b.status)),
                    daysSinceEpoch(b.launchDate) - daysSinceEpoch(a.launchDate),
                    alphabeticallySort(a.name,b.name)
                  ]),
                  renderCell:(item) => (<span>{formatStatus(item.status)}</span>)
                },

                {
                  display:'Start Date',
                  name:'startdate',
                  width:15,
                  sortFunc:(a,b) => firstNonZeroOrOne([
                    daysSinceEpoch(b.launchDate) - daysSinceEpoch(a.launchDate),
                    alphabeticallySort(a.name,b.name),
                    statusSort(a.status, b.status)
                  ]),
                  renderCell:(item) => (
                    <span>
                      {moment(item.launchDate).format('MMM D, YYYY')}
                    </span>
                  )
                },
                {
                  display:'Experience',
                  name:'name',
                  width:25,
                  sortFunc:(a,b) => firstNonZeroOrOne([
                    alphabeticallySort(a.name,b.name),
                    daysSinceEpoch(b.launchDate) - daysSinceEpoch(a.launchDate),
                  ]),
                  filterFunc:(a,searchParam) => textContains(a.name,searchParam) || textContains(a.brandName,searchParam),
                  renderCell:(item) => (
                    <div>
                      <h6>
                        <Link to={`/superadmin/experiences/${item.id}/review`}>
                          {this.renderName(item.name)}
                        </Link>
                      </h6>
                      <strong className='BreakWordOnWrap'>
                        {this.renderName(item.brandName)}
                      </strong>
                      <br />
                      <span>Experience <strong>#{item.salesNumber}</strong></span>
                    </div>
                  )
                },
                {
                  display:'Completions',
                  name:'numCompletions',
                  width:16,
                  sortFunc:(a,b) => firstNonZeroOrOne([
                    b.numCompletions - a.numCompletions,
                    daysSinceEpoch(b.launchDate) - daysSinceEpoch(a.launchDate),
                    alphabeticallySort(a.name,b.name)
                  ]),
                  renderCell:(item) => (<span>{item.isOrHasBeenLive && item.numCompletions.toLocaleString()}</span>)
                },
                {
                  display:'Rating',
                  name:'averageRating',
                  width:13,
                  sortFunc:(a,b) => firstNonZeroOrOne([
                    b.averageRating - a.averageRating,
                    daysSinceEpoch(b.launchDate) - daysSinceEpoch(a.launchDate),
                    alphabeticallySort(a.name,b.name)
                  ]),
                  renderCell:(item) => (
                    <div>
                      {(item.isOrHasBeenLive && item.numCompletions > 0) && (
                        <span>
                          <img
                            src={emojiUrlForRating(item.averageRating)}
                            className='EmojiRating'
                            alt='rating'
                          />
                          &nbsp;&nbsp;
                          <span>{(item.averageRating + 1).toFixed(2)}</span>
                        </span>
                      )}
                      {(item.isOrHasBeenLive && item.numCompletions === 0) && (
                        <span>N/A</span>
                      )}
                    </div>
                  )
                },
                {
                  display:'Budget',
                  name:'lifetimeBudget',
                  width:17,
                  sortFunc:(a,b) => firstNonZeroOrOne([
                    parseFloat(b.lifetimeBudget || 0) - parseFloat(a.lifetimeBudget || 0),
                    daysSinceEpoch(b.launchDate) - daysSinceEpoch(a.launchDate),
                    alphabeticallySort(a.name,b.name)
                  ]),
                  renderCell:(item) => (
                    <div>
                      <MoneyDisplay>{item.lifetimeBudget}</MoneyDisplay>
                      {item.isOrHasBeenLive && (
                        this.budgetValue(item, item.budgetSpent)
                      )}
                    </div>
                  )
                },
                {
                  width:20,
                  renderCell:(item) => this.renderButtonsForCampaign(item)
                }
              ]}
            />
            <br />
            <br />
            <br />
          </Col>
        </Row>
      </Container>
    )
  }
}

export default ProviderCampaignList;



// WEBPACK FOOTER //
// ./src/routes/ProviderCampaignList/components/ProviderCampaignList.js